import styled from 'styled-components'

export const TagContent = styled.div`
  > div > span {
    display: flex;
    margin: 0;
  }
`
export const HeaderWin = styled.div`
  position: relative;
  text-align: center;
`
export const Banner = styled.div<{ $grayedOut: boolean }>`
  border-radius: 8px;
  background-color: ${({ $grayedOut }) => ($grayedOut ? 'var(--gray100)' : 'var(--primary100)')};
  margin-bottom: 16px;
  display: flex;
  align-items: flex-end;

  img {
    width: 100%;
    ${({ $grayedOut }) => $grayedOut && 'filter: grayscale(1);'}
  }
`

export const AlertContent = styled.div`
  > div {
    align-items: center;
    margin-top: 16px;
  }
`
